import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter, Link } from 'react-router-dom';
import { Breadcrumbs, ListPagination } from '../../../../../../components/UI/ComponentsUI';
import { translate, groupBy } from '../../../../../../utils/util';
import ConfirmModalDelivery from './ConfirmModalDelivery';
import DeliveryService from '../../../../../../services/DeliveryService';
import { ENUMS } from '../../../../../../utils/constants';

const DeliveryOrders = (props) => {
    const messageModal = useRef();
    const [currentPage, setCurrentPage] = useState(0);
    const [ordersGroup, setOrders] = useState([]);

    useEffect(() => {
        setOrders(props.groupDelivery?.groupOrdesDelivery);
        //eslint-disable-next-line
    }, [props.groupDelivery?.groupOrdesDelivery]);

    const subtitlesPickingFilterByUser = () => {
        return [{ icon: "business_center", label: `${translate('delivery:fields.routes')} ${translate('delivery:fields.pdus')}` }];
    }

    const isValidConfirm = () => {
        const orders = [];
        const array = [];

        ordersGroup.map((g) => orders.push(g.orders));

        if (!orders) {
            return false;
        }
        orders.forEach(element => {
            const item = element[0].items[0];
            array.push(item)
        });

        const itensCheck = array.filter((f) => f.status === ENUMS.eOrderItemStatus.InProgress.value);
        if (itensCheck.length > 0 && itensCheck.length === array.length) {
            return true;
        }
        return false;
    }

    const onConfirmModal = (qrCode) => {
        props.confirmation(qrCode, () => {
            props.history.replace({
                pathname: `../delivery/startDelivery`
            });
        });
    }

    const renderListOrder = () => {
        let groupOrderRoute = [];
        if (props.groupDelivery?.groupOrdesDelivery) {
            groupOrderRoute = groupBy(props.groupDelivery?.groupOrdesDelivery.filter((i) => i.routeId !== null), 'routeId');
        }

        return (
            groupOrderRoute && groupOrderRoute.map((item) =>
            (<Link
                className="row"
                to={{ pathname: '../delivery/orders', state: { routeId: item.value[0].routeId } }}
                style={{ display: 'block', marginBottom: '0px' }}
            >
                <span className="title sixth-text-color" style={{ marginLeft: '10px' }} >
                    <i className="mdi mdi-map-marker-path" /> {item.value[0].orders[0].routeCode || ''}
                </span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px', paddingBlockEnd: '10px' }}>
                    {translate('delivery:general.totalItens')}: {item.value.length}
                </span>
            </Link>)
            )
        )
    }

    return (
        <div>
            <Breadcrumbs id="deliverypduTitelRoute" title={{ icon: "mdi mdi-camera-timer", label: translate('title', 'delivery') }} subtitles={subtitlesPickingFilterByUser()} />
            <div className="container-fluid" style={{ marginTop: '40px' }}>
                <ListPagination
                    page={0}
                    current={{ currentPage, setCurrentPage }}
                    data={renderListOrder()}
                />
            </div>
            {
                isValidConfirm() && (<div className="row" style={{ marginBottom: '0px' }}>
                    <button
                        type="button"
                        className="col s12 m3 btn btn-principal waves-effect waves-light"
                        style={{ width: '100%' }}
                        onClick={() => messageModal.current.show()}
                    >
                        {translate('delivery:general.finish')}
                    </button>
                </div>)
            }
            <ConfirmModalDelivery
                ref={messageModal}
                id="confirmOrderStart"
                data={{ title: translate('validations:attention'), message: `${translate('delivery:message.confirmNextPdu')}` }}
                onConfirm={onConfirmModal}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        groupDelivery: state.deliveryReducer.deliveryGroup,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        confirmation: (item, callback) => {
            dispatch(DeliveryService.ConfirmationDeliveryPdu(item, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DeliveryOrders)));

